import moment from 'moment'

// ジョブコミ独自の休憩時間バリデーション。勤務時間(開始〜終了)を日中/深夜(22:00〜翌5:00)に分割し、
// アルムニア新規掲載CSV取込時のエラー(E116〜E119)となる休憩時間を事前に検知する。
// data-break-band(daytime/midnight)で対象の時間帯、data-duration-start-key/data-duration-end-key
// (実働時間の算出元)で開始・終了時間フィールドを指定する。
// サーバー側(Customs::JobKomi::WorkTimeBands)にも同じロジックがあるため、変更時は両方を揃えること。

const MINUTES_PER_DAY = 24 * 60
const MIDNIGHT_FROM = 22 * 60 // 22:00
const MIDNIGHT_TO = 5 * 60 // 翌5:00
const DAYTIME_LABEL = '日中(5:00〜22:00)'
const MIDNIGHT_LABEL = '深夜(22:00〜翌5:00)'

// 開始〜終了を0:00起点の分で表した時の深夜帯(2日分。日跨ぎは最大翌日まで)
const MIDNIGHT_RANGES = [
  [0, MIDNIGHT_TO],
  [MIDNIGHT_FROM, MINUTES_PER_DAY + MIDNIGHT_TO],
  [MINUTES_PER_DAY + MIDNIGHT_FROM, MINUTES_PER_DAY * 2]
]

// toggle-form.jsのtoggle-trigger-keyと同様、同じフォーム内の別フィールドを
// (nameのkey部分を置換して)キー名で参照する。form-validator.jsのfindFieldByKeyと同じ実装。
const findFieldByKey = (el, key) => {
  const form = $(el).closest('form')
  const name = $(el).attr('name')
  const targetName = name.replace(/\[(?!.*\[).*/, '[' + key + ']')
  return form.find('input[name="' + targetName + '"],select[name="' + targetName + '"]')
}

// 開始・終了時間(datetime-local)から日中/深夜それぞれの勤務時間(分)を算出する。
// どちらか未入力の場合はnull(判定不可のため呼び出し元でスキップ)
const getWorkMinutesByBand = (el) => {
  const startVal = findFieldByKey(el, $(el).data('duration-start-key')).val()
  const endVal = findFieldByKey(el, $(el).data('duration-end-key')).val()
  if (!startVal || !endVal) {
    return null
  }
  const start = moment(startVal, "YYYY-MM-DDTHH:mm")
  const end = moment(endVal, "YYYY-MM-DDTHH:mm")
  const startMinutes = start.hours() * 60 + start.minutes()
  let endMinutes = end.hours() * 60 + end.minutes()
  // 終了時間が開始時間より前の場合は翌日終了(日跨ぎ)として扱う
  if (endMinutes < startMinutes) {
    endMinutes += MINUTES_PER_DAY
  }
  const midnight = MIDNIGHT_RANGES.reduce((sum, [from, to]) => {
    return sum + Math.max(Math.min(endMinutes, to) - Math.max(startMinutes, from), 0)
  }, 0)
  return { daytime: (endMinutes - startMinutes) - midnight, midnight }
}

// form-validator.jsの'job_komi_break_time_band'ルールから呼び出される。
// エラーがあればエラーメッセージ、なければnullを返す。実働0分ちょうどは許容する。
// 勤務0分の帯に休憩を設定(E118/E119)は実働マイナス(E116/E117)より原因が明確なため優先する
export const getJobKomiBreakTimeBandError = (value, el) => {
  if ($(el).prop('disabled') || $(el).prop('readonly')) {
    // readonly(編集不可)のフィールドは本人が変更できないため判定しない
    return null
  }
  if (!value) {
    return null
  }
  const breakMinutes = Number(value)
  if (isNaN(breakMinutes)) {
    return null
  }
  const workMinutes = getWorkMinutesByBand(el)
  if (workMinutes === null) {
    return null
  }

  const isMidnight = $(el).data('break-band') === 'midnight'
  const bandMinutes = isMidnight ? workMinutes.midnight : workMinutes.daytime
  const bandLabel = isMidnight ? MIDNIGHT_LABEL : DAYTIME_LABEL
  const bandName = isMidnight ? '深夜' : '日中'
  if (bandMinutes === 0 && breakMinutes > 0) {
    return `${bandLabel}の勤務時間が未設定のため、${bandName}の休憩時間は設定できません。`
  }
  if (bandMinutes - breakMinutes < 0) {
    return `${bandLabel}の休憩時間は勤務時間(${bandMinutes}分)以内で設定してください。`
  }
  return null
}
